export const words = {
  1000000000000: "number.trillion",
  1000000000: "number.billion",
  1000000: "number.million",
  1000: "number.thousand",
  900: "number.nine-hundred",
  800: "number.eight-hundred",
  700: "number.seven-hundred",
  600: "number.six-hundred",
  500: "number.five-hundred",
  400: "number.four-hundred",
  300: "number.three-hundred",
  200: "number.two-hundred",
  100: "number.one-hundred",
  90: "number.ninety",
  80: "number.eighty",
  70: "number.seventy",
  60: "number.sixty",
  50: "number.fifty",
  40: "number.forty",
  30: "number.thirty",
  20: "number.twenty",
  19: "number.nineteen",
  18: "number.eighteen",
  17: "number.seventeen",
  16: "number.sixteen",
  15: "number.fifteen",
  14: "number.fourteen",
  13: "number.thirteen",
  12: "number.twelve",
  11: "number.eleven",
  10: "number.ten",
  9: "number.nine",
  8: "number.eight",
  7: "number.seven",
  6: "number.six",
  5: "number.five",
  4: "number.four",
  3: "number.three",
  2: "number.two",
  1: "number.one",
  0: "number.zero",
  ".": "number.and", // :and cents
  "-": "number.minus", // :minus
  only: "number.only", // :only
}

type WordsKey = keyof typeof words

const hundredToWords = (num: number, t: (_: string) => string) => {
  if (num === 0) return t(words[0])
  const remainingUnits = num % 100
  const singles = remainingUnits > 19 ? num % 10 : 0
  const tens = remainingUnits > 19 ? (num % 100) - singles : remainingUnits
  const hundreds = (num % 1000) - tens - singles
  const result =
    (hundreds ? t(words[hundreds as WordsKey]) + " " : "") +
    (tens ? t(words[tens as WordsKey]) + " " : "") +
    (singles ? t(words[singles as WordsKey]) : "")
  return result.trim()
}

const numberFormat = new Intl.NumberFormat("en-US")
const getUnit = (value: number, numberOfThousands: number) => {
  if (value === 0 || numberOfThousands === 0) return ""
  return words[(1000 ** numberOfThousands) as WordsKey]
}
const normalizeFraction = (str: string) => {
  const normalized = str.length === 1 ? str + "0" : str
  return Number(normalized)
}

export const _numberToWords =
  (t: (_: string) => string = (str) => str) =>
  (num: number) => {
    const parts = numberFormat.formatToParts(num)
    const integers = parts.filter((part) => part.type === "integer")
    const fractions = parts.filter((part) => part.type === "fraction")
    const maxNumberOfThousands = integers.length - 1
    const integerWording = integers.map((part, idx) => {
      const numberOfThousands = maxNumberOfThousands - idx
      const nwords = Number(part.value)
        ? hundredToWords(Number(part.value), t)
        : ""
      const unit = getUnit(Number(part.value), numberOfThousands)
      return (nwords + " " + t(unit)).trim()
    })
    const fractionWording = fractions[0]
      ? hundredToWords(normalizeFraction(fractions[0].value), t).trim()
      : undefined

    const sign = num < 0 ? `${t(words["-"])} ` : ""
    return (
      sign +
      (integerWording.join(" ") || t(words[0])) +
      (fractionWording
        ? " " + t(words["."]) + " " + fractionWording + " " + t(words.only)
        : "")
    )
  }
